module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-device"
  }, [(_vm.display) ? _c('div', {
    class: {
      showPadding: _vm.display
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }]
  }), _vm._v(" "), _c('el-form', {
    ref: "device-form",
    staticClass: "new-device-form",
    attrs: {
      "model": _vm.deviceData,
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Pick a Device Type",
      "prop": "type",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Pick a Device Type",
      "no-data-text": "No types"
    },
    model: {
      value: (_vm.deviceData.type),
      callback: function($$v) {
        _vm.$set(_vm.deviceData, "type", $$v)
      },
      expression: "deviceData.type"
    }
  }, _vm._l((_vm.deviceTypes), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "URL Address of Unit",
      "prop": "ip",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter a URL"
    },
    model: {
      value: (_vm.deviceData.ip),
      callback: function($$v) {
        _vm.$set(_vm.deviceData, "ip", $$v)
      },
      expression: "deviceData.ip"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Port Address",
      "required": "",
      "prop": "port"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter a Port number"
    },
    model: {
      value: (_vm.deviceData.port),
      callback: function($$v) {
        _vm.$set(_vm.deviceData, "port", $$v)
      },
      expression: "deviceData.port"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name of Device",
      "required": "",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Device Name"
    },
    model: {
      value: (_vm.deviceData.name),
      callback: function($$v) {
        _vm.$set(_vm.deviceData, "name", $$v)
      },
      expression: "deviceData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name of Site",
      "prop": "site",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Site Name",
      "no-data-text": "No Sites"
    },
    model: {
      value: (_vm.deviceData.site),
      callback: function($$v) {
        _vm.$set(_vm.deviceData, "site", $$v)
      },
      expression: "deviceData.site"
    }
  }, _vm._l((_vm.sites), function(site) {
    return _c('el-option', {
      key: site.id,
      attrs: {
        "label": site.name,
        "value": site.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Serial Number",
      "prop": "serial",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Serial Number"
    },
    model: {
      value: (_vm.deviceData.serial),
      callback: function($$v) {
        _vm.$set(_vm.deviceData, "serial", $$v)
      },
      expression: "deviceData.serial"
    }
  })], 1), _vm._v(" "), (_vm.update) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "save"
    },
    on: {
      "click": function($event) {
        _vm.updateDevice()
      }
    }
  }, [_vm._v("Update Device")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.closeForm()
      }
    }
  }, [_vm._v("Cancel")])], 1) : _c('div', [_c('el-button', {
    attrs: {
      "type": "save"
    },
    on: {
      "click": function($event) {
        _vm.newDevice()
      }
    }
  }, [_vm._v("Save Device")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.closeForm()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7ac271c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Devices/NewDevice.vue
// module id = 1155
// module chunks = 12